/**
 * Screenshots Feature — Constants
 *
 * Brand-aligned palette, tool definitions, and dropdown options shared across the
 * 5 screenshot components. ProSuite orange (#FF6600) is the primary CTA color
 * everywhere a Magic Patterns "orange-500" appears.
 */

import { AnnotationKind, ShareAccess, ShareExpiration } from './screenshots.types';

/** 8-color swatch palette for the annotator. ProSuite orange leads. */
export const ANNOTATION_COLORS: ReadonlyArray<string> = [
  '#FF6600', // ProSuite primary orange
  '#EF4444', // red
  '#F59E0B', // amber
  '#10B981', // emerald
  '#3B82F6', // blue
  '#8B5CF6', // violet
  '#EC4899', // pink
  '#111827', // near-black
];

/** Tool definitions for the annotator toolbar. Keyboard shortcuts match MP. */
export interface AnnotatorTool {
  id: AnnotationKind | 'select';
  label: string;
  icon: string; // Material Icon name
  shortcut: string; // single key (case-insensitive)
}

export const ANNOTATOR_TOOLS: ReadonlyArray<AnnotatorTool> = [
  { id: 'select', label: 'Select', icon: 'mouse', shortcut: 'v' },
  { id: 'arrow', label: 'Arrow', icon: 'north_east', shortcut: 'a' },
  { id: 'rect', label: 'Rectangle', icon: 'crop_square', shortcut: 'r' },
  { id: 'highlight', label: 'Highlight', icon: 'highlight', shortcut: 'h' },
  { id: 'pen', label: 'Pen', icon: 'gesture', shortcut: 'p' },
  { id: 'text', label: 'Text', icon: 'title', shortcut: 't' },
];

/** Default stroke widths per annotation kind. */
export const DEFAULT_STROKE_WIDTH: Record<AnnotationKind, number> = {
  arrow: 3,
  rect: 3,
  text: 1,
  highlight: 14,
  pen: 4,
};

/** Minimum capture region dimensions in px. Below this, capture is cancelled. */
export const MIN_REGION_SIZE = 12;

/** Capture toast auto-dismiss in ms. */
export const TOAST_AUTO_DISMISS_MS = 8000;

/** Locate-highlight animation duration in ms. */
export const LOCATE_HIGHLIGHT_MS = 1200;

/** Share dialog dropdown option lists. */
export interface ExpirationOption {
  value: ShareExpiration;
  label: string;
}
export const EXPIRATION_OPTIONS: ReadonlyArray<ExpirationOption> = [
  { value: '24h', label: '24 hours' },
  { value: '7d', label: '7 days' },
  { value: '30d', label: '30 days' },
  { value: 'never', label: 'Never' },
];

export interface AccessOption {
  value: ShareAccess;
  label: string;
  description: string;
  icon: string;
}
export const ACCESS_OPTIONS: ReadonlyArray<AccessOption> = [
  { value: 'anyone', label: 'Anyone', description: 'Anyone with the link', icon: 'public' },
  { value: 'restricted', label: 'Restricted', description: 'Recipients only', icon: 'group' },
  { value: 'password', label: 'Password', description: 'Password protected', icon: 'lock' },
];
